import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const Wrapper = styled.div`
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${defaultBreakpoints.medium}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const SelectWrapper = styled.div`
  width: 250px;
  display: flex;
  align-items: center;
  @media (max-width: ${defaultBreakpoints.medium}) {
    width: 100%;

    select {
      width: 100%;
    }
  }
`;

export const FilterIntro = styled.p`
  font-family:${({ theme }) => theme.default.fontFamily.primaryFont};
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  text-align: left;
  margin: 0 50px 0 0;

   @media (max-width: ${defaultBreakpoints.medium}) {
    margin: 0;
   }
`;

